import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { LiftBySpotFullComponent } from './lift-by-spot-full.component';

@NgModule({
  imports: [CommonModule, FlexLayoutModule.withConfig({ useColumnBasisZero: false }), SharedModule],
  declarations: [LiftBySpotFullComponent],
  exports: [LiftBySpotFullComponent]
})
export class LiftBySpotFullModule {}
